import type { Props } from "~/components/search/SearchResult"
export { default, loader } from "~/components/search/SearchResult"

// neverDefer + sync so the products render directly in the SSR HTML (no
// React.lazy Suspense boundary that streams empty in dev). Mirrors miami's
// eager PLP pattern but adds sync to skip the lazy-loaded path that was leaving
// the section as <template id="B:N"></template> placeholders.
//
// `neverDefer` (not `eager`) is required because on category PLPs this section
// sits at index 6, which is >= `foldThreshold` (6, see src/setup.ts). The
// `eager` flag only protects sections BELOW the fold threshold; above it, the
// position-based rule would still defer the section into a separate resolve
// pass with a fresh memo Map. That fresh pass re-resolves the shared
// `Produtos do Departamento` PLP block — already resolved eagerly by PageSEO
// and RedirectDepartments — causing a duplicate Intelligent Search
// `product_search` call. `neverDefer` keeps it in the eager pass so all three
// references to the same block dedupe to a single call via the resolve memo.
export const neverDefer = true;
export const sync = true;

export function LoadingFallback(_props: Partial<Props>) {
  return (
    <div className="w-full py-8">
      <div className="container mx-auto px-4">
        <div className="h-6 w-48 bg-base-200 animate-pulse rounded mb-4" />
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="flex flex-col gap-2">
              <div className="aspect-square bg-base-200 animate-pulse rounded" />
              <div className="h-4 bg-base-200 animate-pulse rounded w-3/4" />
              <div className="h-4 bg-base-200 animate-pulse rounded w-1/2" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
